import classes from './StateStep.module.scss'
import { HiOutlineCode } from 'react-icons/hi'
import type { StateType } from '@eggplant/types'

export interface Props {
  name: string
  type?: StateType | 'Stateless'
  isFailed?: boolean
  hasSnippet?: boolean
}

const StateStep = ({
  name,
  type = 'Normal',
  isFailed = false,
  hasSnippet = false
}: Props) => {
  const backgroundColor = isFailed
    ? 'failed'
    : type

  return (
    <div className={classes.StateStep + ' ' + classes[backgroundColor]}>
      {name}
      {
        hasSnippet &&
          <HiOutlineCode
            aria-hidden
            size={18}
          />
      }
    </div>
  )
}

export default StateStep
